<template>
  <!--弹框5 开始-->
  <el-dialog :visible.sync="frameQuotationDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center style="text-align: center;">
    <div style="width:100%;text-align: center;">
      <div><img src="/static/img/frame/refresh-11.png" class="frame-small-img lucid-img" @click="refresh"></div>
      <div style="height:74px; line-height: 74px;font-size: 16px;color: #4F4C4C;text-align: center;" class="wordBreak">{{$t('confirmingPriceIng')}}~</div>
    </div>
  </el-dialog>
  <!--弹框5 结束-->
  <!--引入方式-->
  <!-- <frameQuotation :frameQuotationDialog="frameQuotationDialog"></frameQuotation> -->
</template>

<script>
export default {
  name: 'frameQuotation',
  props: ['frameQuotationDialog'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false
    }
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    refresh () {
      location.reload()
      this.frameDialog = false
      this.frameRiseDialog = false
    }
  }
}
</script>

<style scoped>
.frame-small-img{width:80px; height:80px;cursor: pointer;}
.lucid-img{-webkit-filter: opacity(90%); /* Chrome, Safari, Opera */ filter: opacity(90%);-webkit-transform: rotate(360deg);animation: rotation 3s linear infinite;-moz-animation: rotation 3s linear infinite;-webkit-animation: rotation 3s linear infinite;-o-animation: rotation 3s linear infinite;}
@-webkit-keyframes rotation{
    from {-webkit-transform: rotate(0deg);}
    to {-webkit-transform: rotate(360deg);}
}

</style>



// WEBPACK FOOTER //
// src/components/public/frameQuotation.vue